import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { AuthService } from "app/services/auth.service";
import { LocalService } from "app/services/local.service";
import { PageService } from "app/services/page-service";

@Component({
  selector: "app-failure",
  templateUrl: "./failure.component.html",
})
export class FailureComponent implements OnInit {
  @Input() failureContent: any;
  planRecord = {};
  planType = "monthly";
  activePlan = {};
  planDetails = {};
  loader = false;
  errorMessage = "";
  errorStatus = undefined;

  constructor(
    public service: PageService,
    public authService: AuthService,
    public router: Router,
    public localService: LocalService,
    public dialogRef: NgbActiveModal
  ) {}

  ngOnInit() {
    this.loader = true;
    this.errorStatus = this.failureContent.message.status;
    // console.log(this.failureContent);
    this.prepareErrorMessage();
  }

  prepareErrorMessage() {
    if (typeof this.failureContent.message === "object") {
      this.errorStatus = this.failureContent.message.status;
      console.log(this.errorStatus);
      this.failureContent.message = "";
    }

    if (this.failureContent.message === "") {
      switch (this.errorStatus) {
        case 400:
          this.errorMessage = "Bad Request, Please try again after some time.";
          break;
        case 401:
          this.errorMessage = "Invalid Email or Password Entered";
          break;
        case 403:
          this.errorMessage = "You are not authorised to access.";
          break;
        case 404:
          this.errorMessage =
            "Sorry, We are unable to process your request. Please try after some time.";
          break;
        case 500:
          this.errorMessage =
            "Please check your Internet Connection or Try after sometime";
          break;
        case 0:
          this.errorMessage = "Please check your internet connection.";
          break;
        default:
          this.errorMessage = "Something went wrong, Please try after sometime";
          break;
      }
    } else {
      this.errorMessage = this.failureContent.message;
    }
  }

  close() {
    this.dialogRef.close({ success: false });
    // console.log(this.errorStatus);
    if (this.errorStatus === 500) {
      // this.errorMessage = 'Please, check your internet connection.';
      localStorage.removeItem("token");
      localStorage.removeItem("userDetails");
      this.router.navigate(["/login"]);
    }
    if (
      this.failureContent.message === "This order has already been delivered!!"
    ) {
      window.location.reload();
    }
  }
}

/**
 * 400: Bad Request, Please try again after some time.
 * 401: You are not authorised to access.
 * 403: Same
 * 404: Sorry, We are unable to process your request. Please try after some time.
 * 500: Same
 */
